import "./EntryPage.less";

import * as QueryString from "query-string";
import * as React from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";

import { IBaseProps } from "lib/data/interfaces";

import { SearchBar } from "components/general";
import { SearchPage } from "components/pages";
import { EntryView } from "components/views";


interface IEntryPageProps extends IBaseProps, RouteComponentProps<any> {

}

interface IEntryPageState {

}


export class EntryPage extends React.Component<IEntryPageProps, IEntryPageState> {

	public static readonly BasePath: string = "/entry";

	constructor(props: IEntryPageProps) {

		super(props);

		this.state = {

		};
	}

	public render() {

		const searchQueryString = QueryString.parse(this.props.location.search).q;
		let searchQuery: string | undefined;

		if (searchQueryString) {

			// Check If Query Returns Multiple
			if (Array.isArray(searchQuery)) {

				// Concatenate Search Queries
				searchQuery = searchQuery.join(" ");
			}
			else {

				// Store Search Query As-Is
				searchQuery = searchQueryString as string;
			}
		}

		// Render Normally
		return (
			<div className="entry-page">

				{/* <header className="introduction">

					<h3>Government Directory</h3>

					<div className="spacer-10-h" />

					<SearchBar placeholder="What are you looking for today?" onSearch={this.onDirectorySearched} searchString={searchQuery} />

					<div className="spacer-10-h" />

				</header> */}

				<section className="page-content">

					<Switch>
						<Route exact={true} path={`${EntryPage.BasePath}/:id`} component={EntryView} />
					</Switch>

				</section>

			</div>
		);
	}

	private onDirectorySearched = (searchString: string) => {
		// Redirect To Search Page
		this.props.history.push(`${SearchPage.BasePath}?q=${searchString}`);
	}
}
